// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyA9BK8VMqj3_yGgdnMCdVxnYvVfU2yI8EI",
  authDomain: "joy-aura.firebaseapp.com",
  projectId: "joy-aura",
  storageBucket: "joy-aura.firebasestorage.app",
  messagingSenderId: "1076135056195",
  appId: "1:1076135056195:web:02837d3763783db98555f6",
  measurementId: "G-K1YBNNWPYT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export services
export const auth = getAuth(app);
export const storage = getStorage(app);